<div *ngFor="let section of sections">
  <h4 *ngIf="section.heading">{{ section.heading }}</h4>
  <div [innerHTML]="section.body | mdToHtml"></div>
</div>
